<div class="footer-pages wrap container-fluid">
  <h1>About Us</h1>
  <p>
    JourneyAL
  </p>
</div>